import React from 'react'

export const ModalRoot: React.FCC = () => {
  return <div id="modal-root" data-testid="modal-root" />
}
